import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    ScrollView,
    StyleSheet,
    Picker,
    ActivityIndicator,
    Alert,
    ToastAndroid,
    KeyboardAvoidingView
} from 'react-native';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { Formik, FormikProps } from 'formik';
import { AuthContext } from '../../contexts/auth/Store';
import * as Yup from 'yup';
import FormikSelectList from '../form/FormikSelectList';

import { AnalyticsService } from "../../constants/Analytics";
import { useNavigation } from '@react-navigation/native';
import StyledButton from '../StyledButton';
import http from '../../utils/http';

const analytics = new AnalyticsService

const LocationSchema = Yup.object().shape({
    location_id: Yup.string()
        .required('Select a location')
});

function UpdateStoreLocation() {
    const navigation = useNavigation()
    const auth = React.useContext(AuthContext)

    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [locations, setLocations] = React.useState([])

    const submit = (values, setSubmitting, resetForm) => {
        try {
            let form = new FormData()
            form.append('_id', buyer._id)
            form.append('person', buyer.person)
            form.append('phone', buyer.phone)
            form.append('name', buyer.name)
            form.append('store_type_id', buyer.store_type_id)
            form.append('location_id', values.location_id)
            form.append('address', buyer.address)
            form.append('status', buyer.status)
            form.append('user_id', buyer.user_id)

            http.post('buyer/update', form, token).then(res => {
                setSubmitting(false)
                if (res.code == 200 && res.message) {
                    const location_data = locations.find(item => item._id === values.location_id)
                    const updatedBuyer = Object.assign({}, buyer, values, { location: location_data })
                    auth.updateUserData(updatedBuyer)
                    // ToastAndroid.show('Profile update successful', ToastAndroid.LONG, ToastAndroid.BOTTOM)

                    analytics.logEvent('Updated Store Location', updatedBuyer)
                } else {
                    // console.log(res)
                    // ToastAndroid.show('Failed. Try again', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                }
            })
        } catch (e) {
            // ToastAndroid.show('Error. Try again', ToastAndroid.LONG, ToastAndroid.BOTTOM)
            setSubmitting(false)
            console.log(e)
        }
    }

    React.useEffect(() => {
        let clean_up = false
        navigation.addListener('focus', () => {
            if (navigation.isFocused()) {

                const loadStoreTypes = async () => {

                    let store_locations = await AsyncStorage.getItem('storeLocations')
                    store_locations = JSON.parse(store_locations)

                    if (!clean_up) { setLocations(store_locations || []) }

                    http.post('location/read_all', null, null).then((data) => {
                        let list = data.data.filter(item => {
                            return item.status === 'active' && item.name !== "Other*"
                        })
                        AsyncStorage.setItem('storeLocations', JSON.stringify(list))
                        if (!clean_up) { setLocations(list) }
                    })
                }

                loadStoreTypes()
            }
        })

        return () => {
            clean_up = true
            navigation.removeListener("focus")
        }

    }, [])

    return (
        <View style={{ flex: 1 }}>
            <KeyboardAvoidingView keyboardVerticalOffset={-500} enabled={true} behavior={'position'}>
                <ScrollView contentContainerStyle={{ height: '100%' }}>
                    <Formik
                        initialValues={
                            {
                                location_id: '',
                            }
                        }
                        validationSchema={LocationSchema}
                        onSubmit={
                            (values, actions) => {
                                submit(values, actions.setSubmitting, actions.resetForm)
                            }
                        }
                    >
                        {({ handleSubmit, values, isSubmitting, setFieldValue, isValid }) => (
                            <View style={styles.container}>
                                {/* form goes here */}
                                <FormikSelectList
                                    fieldName="location_id"
                                    placeholder="Select your store location"
                                    options={locations}
                                />

                                <StyledButton
                                    label="Set Location"
                                    submitting={isSubmitting}
                                    disabled={(isSubmitting || !isValid)}
                                    action={handleSubmit}
                                    style={{
                                        marginTop: 32,
                                        marginBottom: 63
                                    }}
                                />
                            </View>
                        )}
                    </Formik>

                </ScrollView>
            </KeyboardAvoidingView>
        </View>
    )
}

export default UpdateStoreLocation

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 61,
        paddingHorizontal: 16
    },
})